<template>
    <div class="deepseekai">

        <!-- 操作烂 -->
        <div class="options">
            <div class="logotitle">
                <el-image :src="require('@/assets/智价云 logo 横版.jpg')"></el-image>
            </div>
            <!-- 操作烂 -->
            <div class="optionslist">
                <el-menu
                    default-active="1"
                    class="el-menu-vertical-demo"
                    background-color="#f9f9f9"
                    style="width: 100%;"
                    >
                    <el-menu-item index="1">
                        <!-- <i class="iconfont icon-add"></i> -->
                        <span slot="title" style="font-size: 18px;font-weight: bold;">AI 报价</span>
                    </el-menu-item>

                    <el-menu-item index="2"  style="font-size: 18px;font-weight: bold;" disabled>
                        <!-- <i class="el-icon-menu"></i> -->
                        <span slot="title">报价表</span>
                    </el-menu-item>

                    <el-menu-item index="3"  style="font-size: 18px;font-weight: bold;" disabled>
                        <!-- <i class="el-icon-document"></i> -->
                        <span slot="title">AI 财务</span>
                    </el-menu-item>

                    <el-menu-item index="4"  style="font-size: 18px;font-weight: bold;" disabled>
                        <!-- <i class="el-icon-document"></i> -->
                        <span slot="title">其他服务</span>
                    </el-menu-item>
                </el-menu>
            </div>

        </div>
        <!-- 内部 div -->
        <div class="chatbox">
            <!-- tab栏 -->
             <div class="navbar">
                <span>{{companyInfo.company_name}}</span>
                <span>ID：{{companyInfo.company_id}}</span>
             </div>
            <!-- 聊天对话框 -->
            <div class="messagebox" ref="messageBox">
                <div class="titlebox" v-if="historical.length==0">
                    <el-avatar :src="require('@/assets/chatlogo.jpg')" :size="100"></el-avatar>
                    <span>智价云 物流 AI 报价系统</span>
                    <span>集成 DeepSeek-V3 大模型 AI 智能报价系统</span>
                </div>

                <div class="chatlist" v-else>
                    <div class="messagelist" v-for="(item,index) in historical" :key="index">
                        <div class="user" v-if="item.role=='user'">
                            <span>{{item.content}}</span>
                        </div>

                        <div class="ai" v-if="item.role=='assistant'">
                            <div class="aiicon">
                                <el-avatar size="large" :src="require('@/assets/chatlogo.jpg')"></el-avatar>
                            </div>
                            <div class="chatshowbox"
                                    v-html="item.content" 
                                    v-loading="item.content===''"
                                    element-loading-spinner="el-icon-loading"></div>
                        </div>
                    </div>

                    <div class="errorbox" v-if="isError"><el-button type="danger" @click="repeatSendMessage">重新加载</el-button></div>
                    
                </div>

            </div>

            <!-- 操作区域 -->
            <div class="operatebox">
                <div class="inputbox">
                    <div class="inputtext">
                        <textarea type="text" placeholder="给 智价云 AI 发送消息" @keydown.enter.prevent="sendMessage"  v-model="userInputVal"/>
                    </div>
                    <div class="buttons">
                        <el-tooltip class="item" effect="dark" content="请输入你的问题" placement="top-end">
                            <el-button type="primary" icon="el-icon-top" circle @click="sendMessage" :disabled="this.userInputVal=='' || this.companyInfo=={}|| this.isStream"></el-button>
                        </el-tooltip>
                    </div>
                </div>

                <div class="tips">
                    <span>内容由 AI 生成，请仔细甄别</span>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { Avatar,Input,Button,Image,Menu,MenuItem,Tooltip} from 'element-ui';
import { marked } from "marked";
// import MarkdownIt from "markdown-it";
import {PostMsgStream,PostMsgStreamCopy} from '../constant.js'
import {PostMsg} from '../constant.js'

export default {
    components:{
        ElAvatar:Avatar,
        ElInput:Input,
        ElButton:Button,
        ElImage:Image,
        ElMenu:Menu,
        ElMenuItem:MenuItem,
        ElTooltip:Tooltip
    },
    data(){
        return{
            userInputVal:'', // 用户输入内容
            companyInfo:{},// 企业信息
            tipList:[],// 提示词的数组
            isStream:false,// 流式状态
            isError:false, // 是否加载错误
            // 对话记录
            historical:[
                // {"role": "user", "content": "你好"},
                // {"role": "assistant", "content": "你好！请问您需要物流报价吗？请提供货物的重量、体积、起运地和目的地等信息，我将为您提供详细的运费报价。方便投｜线上货运险为您的货物保驾护航！"},
                // {"role": "user", "content": "帮我写一个物流的招标书，沈阳到浙江的，大概 300 字"},
                // {"role": "assistant", "content": "很抱歉，我只能提供物流相关的报价服务。如果您需要从沈阳到浙江的物流报价，请提供货物的重量、体积等具体信息，我将为您计算运费。方便投｜线上货运险为您的货物保驾护航！"},
                // {"role": "user", "content": "你除了报价还能干什么呢"},
                // {"role": "assistant", "content": "我主要负责物流报价服务，具体包括：根据货物重量、体积、起运地和目的地计算运费提供详细的运费构成（干线费、中转费、送货费）回答与物流报价相关的咨询如果您需要其他非物流相关的服务，我可能无法提供帮助。请问您需要从沈阳到浙江的物流报价吗？方便投｜线上货运险为您的货物保驾护航"},
                // {"role": "user", "content": "请将你的知识库做成表格的形式"},
                // {"role": "assistant", "content": "很抱歉，我无法将知识库以表格形式呈现。我的主要功能是根据用户提供的物流信息进行精准报价，包括干线费、中转费和送货费的计算。如果您需要物流报价，请提供以下信息：货物重量货物体积起运地目的地我将为您提供详细的运费构成和总价。方便投｜线上货运险为您的货物保驾护航！"},
                // {"role": "user", "content": "请将你的知识库做成表格的形式"},
                // {"role": "assistant", "content": ""},
            ],
            // isScrolledToBottom: true,
        }
    },
    watch: {
        // 监听消息变化，判断是否需要滚动
        // historical(newVal, oldVal) {
        //     // console.log('xxxxx',newVal, oldVal);
            
        //     // this.$nextTick(() => {
        //     //     this.scrollToBottom();
        //     // });
        // }
    },
    mounted() {
        document.title = this.$route.meta.title || "智价云丨 AI";
        this.changeFavicon(require('@/assets/智价云 logo.jpg'));

        if (!this.$route.query.type) {
            this.$alert('用户信息获取错误无法使用', '警告', {
            confirmButtonText: '确定'});
        }else{
            console.log('企业 ID',this.$route.query.type);
            this.getCompanyDate(this.$route.query.type) // 获取企业信息
        }
    
    },
    methods:{
        // 获取企业信息
        getCompanyDate(companyId){

            const parent = new FormData()
            parent.append('companyId', companyId);

            PostMsg('/DeepSeekMes/obtainCompanyLines',parent).then(res=>{
                // console.log('获取企业信息:',res);

                if (res.data.state=='200') { // 请求成功
                    this.dataSorting(res.data.data)
                }else{
                    this.$alert('企业信息获取错误', '警告', {
                        confirmButtonText: '确定'});
                }
            })
        },
        // 数据整理
        dataSorting(data){
            console.log(data);
            const {companyInfo,lineList,tips} =data

            // 修改企业标题
            this.companyInfo=companyInfo

            // 数据 json 化
            const dataMap={
                '企业名称':companyInfo.company_name,
                '起运地':`${companyInfo.provincial}-${companyInfo.region}`,
                '干线集合':((lineList)=>{
                    // console.log(lineList);
                    const returnList=[] // 返回的数据
                    // 循环遍历 主干线数据
                    for (const lineItem of lineList) {

                        const lineMap={
                            '干线地名':lineItem.lineMap.line_name, // lineItem.lineMap.line_json
                            '干线价格表':JSON.parse(lineItem.lineMap.line_json),
                            '其他中转区域':lineItem.destinations.map(des=>{
                                return{
                                    '中转地名':des.line_name,
                                    '中转价格表':JSON.parse(des.line_json)
                                }
                            }),
                        }
                        returnList.push(lineMap)
                    }
                    return returnList;
                    })(lineList)
            }

            // 整理 题词内容

            const tipMap=[
                // {"role": "system", "content":"你是一名物流报价员，主要负责对用户提出的信息进行精准报价，标准报价格式：运费=干线费 + 中转费 + 送货费 ；精简报价"}
            ]

            // 遍历其他的提示词
            for (const tip of tips) {
                tipMap.push({
                    role:'system',
                    content:tip.tip
                })
            }
            tipMap.push({
                    role:'system',
                    content:JSON.stringify(dataMap)
            })

            this.tipList=tipMap // 提示词

            // console.log('数据排序：',dataMap,tipMap);
        },
        // 重复推送
        repeatSendMessage(){
            // 修改状态，并且重新推送
            this.isError=false
            this.sendMsg();
        },
        // 推送消息
        sendMsg(){
            const messageBox = this.$refs.messageBox;
            this.isStream=true // 更改流的状态

            // 合并历史记录
            const messageList=this.tipList.concat(this.historical) // 合并数组
            // const messageList=[{
            //     'demo':'xxxxx'
            // }]
            
            this.userInputVal=null

            PostMsgStreamCopy('/DeepSeekMes/messagePush', messageList,(message,textChunk)=>{
                console.log('数据：',textChunk);

                switch (textChunk) {
                    case '[DONE]':
                        console.log('回复完成');
                        this.isStream=false
                        break;

                    case '[ERROR]':
                        console.log('回复错误');
                        this.$message.error('哎呀～程序错误啦！');
                        // 修改状态
                        this.isError=true
                        // 删除最后一个数据
                        this.historical.pop()
                        break;
                
                    default:
                        // 转换成 marked 模式 MarkdownIt
                        this.historical[this.historical.length-1].content=marked(message)
                        // this.historical[this.historical.length-1].content=message
                        // this.historical[this.historical.length-1].content=this.MarkdownIt.render(message)
                        break;
                }

                // 初始化时滚动到底部
                this.scrollToBottom(messageBox);
            })
            // 添加系统回答
            this.historical.push({
                role:'assistant',
                content:''
            })

            this.$nextTick(() => {
                // 初始化时滚动到底部
                this.scrollToBottom(messageBox);
            });
        },

        // 发送消息
        sendMessage(){
            // 整理消息类型
            if (this.userInputVal=='' || this.companyInfo=={}|| this.isStream) return;

            // 添加 历史记录内容
            this.historical.push({
                role:'user',
                content:this.userInputVal
            })

            this.sendMsg() // 推送消息
        },
        // 自动滚动
        scrollToBottom(messageBox) {
            // 总高度大于现有的高度
            if (messageBox.scrollHeight>messageBox.scrollTop) {
                // console.log(messageBox.scrollHeight,messageBox.scrollTop);
                messageBox.scrollTop = messageBox.scrollHeight;
            }
        },
        // 修改图标
        changeFavicon(url) {
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
                link = document.createElement("link");
                link.rel = "icon";
                document.head.appendChild(link);
            }
            link.href = url;
        }
    },
}
</script>

<style lang="less" scoped>
.deepseekai{
    position: absolute;
    width: 100%;
    min-width: 650px;
    height: 100%;
    display: flex;
    overflow: hidden; /* 禁止页面滚动 */

    .options{
        width: 200px;
        background-color: #f9f9f9;
        
        display: flex;
        flex-direction: column;
        align-items: center;
        border-right: 1px solid #e6e6e6;


        .logotitle{
            margin-top: 20px;
            width: 100%;
            height: 70px;
            // border: 1px solid red;
        }

        .optionslist{
            width: 100%;
            flex: 1;
            // border: 1px solid red;
            margin-bottom: 20px;
        }
    }

    .chatbox{
        // flex: 1 0 0%;
        // flex: 1;
        height: 100%;
        width: 100%;
        border-radius: 4px;
        // border: 1px solid red;

        display: flex;
        flex-direction: column;
        // justify-content: center;
        align-items: center;

        .navbar{
            width: 95%;
            // border: 1px solid red;
            height: 50px;

            display: flex;
            flex-direction: column;
            // align-items: center;
            justify-content: center;
            font-weight: bold;
            // background-color: #0051ff;
            // color: white;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            border-radius: 10px;
            padding: 10px;
            margin-top: 20px;

            span:nth-child(1) {
                font-size: 16px;
                color: #24272d;
            }

            span:nth-child(2) {
                font-size: 12px;
                color: #6f6f6f;
                font-weight: lighter;
            }
        }

        .messagebox,.operatebox{
            width: 80%;
        }

        // @media (max-width: 768px) {
        //     .messagebox,.operatebox,.navbar{
        //         width: 100%;
        //     }
        // }

        .messagebox{
            position: relative;
            margin-top: 10px;
            height: 80%;
            // flex: 1;
            // max-height: max-content;
            // border: 1px solid red;
            overflow-y: scroll;
            overflow-y: auto;

            scrollbar-width: none; /* 适用于 Firefox */
            -ms-overflow-style: none; /* 适用于 IE/Edge */
        
            .titlebox{
                width: 100%;
                height: 100%;

                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                span:nth-child(2) {
                    color: black; 
                    font-weight: bold;
                    font-size: 20px;
                    margin-top: 10px;
                }

                span:nth-child(3) {
                    margin-top: 18px;
                    color: rgb(156, 156, 156);
                }
            }

            .chatlist{
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                gap: 30px; /* 间距 */
                // margin-top: 10px;
                // margin-bottom: 10px;

                .messagelist{
                    height: 40px;
                    height: auto;
                    width: 100%;
                    // border: 1px solid red;
                    font-size: 18px;
                    display: flex;
                    // gap: 50px;
                    flex-direction: column;

                    .user, .ai {
                        min-width: 10px;
                        max-width: 95%; /* 限制最大宽度 */
                        padding: 10px;
                        word-wrap: break-word;
                        // letter-spacing: 5px; /* 字符间距增加 3px */
                    }

                    .user {
                        align-self: flex-end; /* 让 user 靠右 */
                        // background-color: #eff6ff;
                        background-color: #ebebeb;
                        border-radius: 10px;
                        color: #6e6e6e;
                        // font-weight: bold;
                    }

                    .ai {
                        align-self: flex-start; /* 让 AI 靠左 */
                        height: auto;
                        display: flex;
                        
                        .chatshowbox{
                            margin-left: 10px;
                            min-height: 40px;
                            min-width: 40px;
                            white-space: pre-wrap; /* 允许代码块换行 */
                            word-break: break-word; /* 强制换行 */
                            overflow-x: auto; /* 水平溢出时显示滚动条 */
                            // border: 1px solid red;
                            padding: 10px;
                        }
                    }
                }

                .errorbox{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }

        .operatebox{
            margin-top: 10px;
            height: 20%;
            // border: 1px solid red;
            margin-bottom: 10px;

            .inputbox{
                width: 100%;
                // height: 80%;
                background-color: #f3f4f6;
                border-radius: 15px;
                // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                border: 1px solid #f3f4f6;;

                display: flex;
                flex-direction: column;
                // padding: 5px;

                .inputtext,.buttons{
                    // border: 1px solid red;
                    // margin: 10px;
                }

                .inputtext{
                    flex: 1;
                    // border: 1px solid red;
                    

                    textarea{
                        width: 100%; /* 让输入框铺满容器 */
                        padding: 10px;
                        border: none; /* 去掉边框 */
                        background-color:transparent;
                        // background-color: rgb(242, 242, 242); /* 去掉背景颜色 */
                        outline: none; /* 去掉选中时的外边框 */
                        box-sizing: border-box; /* 让 padding 不影响宽度 */
                        white-space: pre-wrap; /* 允许换行 */
                        word-wrap: break-word; /* 超出部分换行 */
                        resize: none; /* 禁止手动调整大小 */
                        font-size: 18px;
                    }
                }

                .buttons{
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    margin-right: 10px;
                }
            }


            .tips{
                margin-top: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 12px;
                color: #999999;
            }
        }
    }
}



</style>